import { Alert, Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import type { FormActivityUI } from "../utils";
import { useLessonForm } from "./LessonFormContext";
import AlternativeCard from "./AlternativeCard";

interface AlternativesPaneProps {
  activity: FormActivityUI;
  activityIndex: number;
}

/**
 * SCRUM-795: la pestaña "Alternativas sin manipulativos" de una actividad
 * manipulativa.
 *
 * Sin límite de cantidad y cada una se borra por separado. El aviso de arriba no
 * es decorativo: una escuela con el interruptor prendido no ve la actividad
 * manipulativa, y si no hay alternativas capturadas no ve NADA en su lugar.
 */
const AlternativesPane: React.FC<AlternativesPaneProps> = ({
  activity,
  activityIndex,
}) => {
  const { addAlternative } = useLessonForm();
  const alternatives = activity.alternatives ?? [];

  return (
    <div className="alternatives-pane">
      {alternatives.length === 0 ? (
        <Alert
          type="warning"
          showIcon
          message="Esta actividad no tiene alternativas"
          description="En las escuelas con “Mate sin manipulativos” o “Lecto sin manipulativos” activado, esta actividad no se muestra. Si no capturas al menos una alternativa, esas escuelas no verán nada en su lugar."
          style={{ marginBottom: 16 }}
        />
      ) : (
        <Alert
          type="info"
          showIcon
          message="Estas actividades reemplazan a la actividad manipulativa"
          description="Se muestran, en este orden, únicamente en las escuelas que tienen desactivados los manipulativos de esta asignatura."
          style={{ marginBottom: 16 }}
        />
      )}

      {alternatives.map((alternative, alternativeIndex) => (
        <AlternativeCard
          key={alternative.id ?? alternativeIndex}
          alternative={alternative}
          activityIndex={activityIndex}
          alternativeIndex={alternativeIndex}
        />
      ))}

      <Button
        type="dashed"
        onClick={() => addAlternative(activityIndex)}
        icon={<PlusOutlined />}
        className="add-alternative-button"
      >
        Añadir actividad alternativa
      </Button>
    </div>
  );
};

export default AlternativesPane;
